export default "__VITE_ASSET__y6hDkB1M__";